import React, { Fragment, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { navtoggle } from "../../../store/actions/AuthActions";
import { ThemeContext } from "../../../context/ThemeContext";

import logoTextWhite from "../../../images/logo-text-white.png";
import logoText from "../../../images/logo.png";
import logoWhite from "../../../images/logo-white.png";

const NavHader = () => {
  const dispatch = useDispatch();
  const sideMenu = useSelector((state) => state.sideMenu);

  const handleToogle = () => {
    dispatch(navtoggle());
  };

  const { navigationHader, openMenuToggle, background } =
    useContext(ThemeContext);

  return (
    <div className="nav-header">

      {/* ✅ LOGO CLICK → DASHBOARD + REFRESH */}
      <a href="/dashboard" className="brand-logo">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <img className="logo-abbr" src={logoWhite} alt="logo" />
            <img className="logo-compact" src={logoTextWhite} alt="logo" />
            <img className="brand-title" src={logoTextWhite} alt="logo" />
          </Fragment>
        ) : (
          <Fragment>
            <img className="logo-compact" src={logoText} alt="logo" />
            <img className="brand-title" src={logoText} alt="logo" />
          </Fragment>
        )}
      </a>

      {/* ✅ MENU TOGGLE */}
      <div
        className="nav-control"
        onClick={() => {
          handleToogle();
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>

    </div>
  );
};

export default NavHader;